module.exports = __webpack_public_path__ + "img/jiqi-txt2.dc953879.png";